export function getFillColor(
  colors: string[],
  index: number,
): string | undefined {
  if (!colors.length) return undefined;
  return colors[index % (colors.length - 1)];
}
